import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home">
      <div className="home-content">
        <header className="home-header">
          <div className="logo-section">
            <img src="/logo.png" alt="SilverScribe" className="logo-img" />
          </div>
        </header>

        <main className="home-main">
          <h1 className="welcome-heading">Welcome! We're currently in stealth mode.</h1>

          <div className="cards-container">
            <div className="info-card">
              <h2>For new visitors</h2>
              <p>
                SilverScribe is currently available to a limited group of stealth users.
                If you'd like to learn more about how we're helping seniors take control
                of their health history, please get in touch.
              </p>
              <Link to="/contact" className="card-btn">
                Contact us
              </Link>
            </div>

            <div className="info-card">
              <h2>For existing users</h2>
              <p>
                If you've already joined our program, you can log in securely below.
              </p>
              <Link to="/login" className="card-btn">
                Log In to SilverScribe
              </Link>
            </div>
          </div>
        </main>

        <footer className="home-footer">
          <nav className="home-footer-links" aria-label="Site links">
            <Link to="/about">About Us</Link>
            <span className="home-footer-sep" aria-hidden="true">·</span>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <span className="home-footer-sep" aria-hidden="true">·</span>
            <Link to="/privacy">Privacy Policy</Link>
          </nav>
          <p>SilverScribe is a Canadian company. &copy; SilverScribe 2025</p>
        </footer>
      </div>

      <div className="decorative-crosses">
        <span className="cross cross-1">+</span>
        <span className="cross cross-2">+</span>
        <span className="cross cross-3">+</span>
        <span className="cross cross-4">+</span>
        <span className="cross cross-5">+</span>
        <span className="cross cross-6">+</span>
        <span className="cross cross-7">+</span>
        <span className="cross cross-8">+</span>
      </div>
    </div>
  );
};

export default Home;
